export default __webpack_public_path__ + "static/media/animation-arrow4.c109fc67.gif";